<template>
  <div>
      <!-- Titulo de la seccion-->
      <b-row class="pb-3">
        <b-col class="align-left">
          <p>
            <span style="float: right; padding-right: 30px">
              <VueToggles
                @click="toggleTimer"
                :value="checked"
                height="30"
                width="90"
                :checkedText="timerCheckText"
                uncheckedText="OFF"
                checkedBg="#b4d455"
                uncheckedBg="lightgrey"
              />
            </span>
            <span  style="float: right; padding-right: 20px; font-size: 16px"
              >Auto-refrescar</span
            >
          </p>
        </b-col>
      </b-row>

      <!-- Tabla con la lista de dispositivos-->

        <div>
          <vue-good-table
            @on-page-change="onPageChange"
            @on-sort-change="onSortChange"
            @on-column-filter="onColumnFilter"
            @on-per-page-change="onPerPageChange"
            :columns="columns"
            :rows="rows"
            :search-options="{
              //enabled: true,
              //trigger: 'enter',
              skipDiacritics: true,
              //searchFn: mySearchFn,
              placeholder: 'Buscar en la tabla',
              //externalQuery: searchQuery
            }"
            :sort-options="{
              enabled: true,
              initialSortBy: { field: 'fecharegistro', type: 'desc' },
            }"
            :pagination-options="{
              enabled: true,
              //mode: 'records',
              //perPage: 10,
              //dropdownAllowAll: false,
              //setCurrentPage: 2,
              nextLabel: '',
              prevLabel: '',
              rowsPerPageLabel: 'Filas por pagina',
              ofLabel: 'de',
              pageLabel: 'pagina', // for 'pages' mode
              allLabel: 'Todas',
            }"
          >
            <template slot="table-row" slot-scope="props">
              <span v-if="props.column.field == 'datagrama'">
                <span :class="estiloDatagrama" @click="activeLink" title="Ampliar datagrama">
                  {{ props.row.datagrama }}
                </span>
              </span>
            </template>
          </vue-good-table>
        </div>
      
    
  </div>
</template>


<script>
// MIRAR EN https://xaksis.github.io/vue-good-table/guide/
import "vue-good-table/dist/vue-good-table.css";
import { VueGoodTable } from "vue-good-table";
import VueToggles from "vue-toggles";
import DatagramService from "@/services/DatagramService";

export default {
  name: "users-list",
  data() {
    return {
      serverParams: {
        columnFilters: {},
        sort: {
          field: "fecharegistro",
          type: "desc",
        },
        page: 1,
        perPage: 10,
      },
      datagram: [],
      currentUser: null,
      currentIndex: -1,
      timerTicks: 30,
      timerCounter: 0,
      timerInterval: 1000,
      timerCheckText: "ON(30)",
      estiloDatagrama: "minDatagram",
      columns: [
        {
          label: "# ID",
          thClass: "text-center",
          tdClass: "text-center",
          field: "id",
        },
        {
          label: "Fecha de registro",
          thClass: "text-center",
          tdClass: "text-center",
          field: "fecharegistro",
          type: "date",
          dateInputFormat: "dd-MM-yyyy HH:mm:ss",
          dateOutputFormat: "dd-MM-yyyy HH:mm:ss",
        },
        {
          label: "Datragrama",
          field: "datagrama",
          thClass: "text-center",
          tdClass: "text-center",
          type: "string",
          width: "100px",
        },
      ],
      rows: [],
      timer: "",
      checked: true,
      expandedIds: [],
    };
  },
  components: {
    VueGoodTable,
    VueToggles,
  },
  methods: {
    activeLink(event) {
      if (event.target.className == "minDatagram") {
        event.target.className = "minDatagramAlt";
      } else {
        event.target.className = "minDatagram";
      }
    },

    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },

    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      this.retrieveDatagrams();
    },

    onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage });
      this.retrieveDatagrams();
    },

    async onSortChange(params) {
      //onSortChange executes before retrieveDataFromSensor (which prepares the metadata neccesary), so it have to wait
      if (this.columns.length && this.columns.length > 0) {
        this.updateParams({
          page: 1,
          sort: {
            type: params[0].type,
            field: params[0].field,
          },
        });
        this.retrieveDatagrams();
      }
    },

    onColumnFilter(params) {
      this.updateParams(params);
      this.retrieveDatagrams();
    },

    retrieveDatagrams() {
      DatagramService.getDatagramDebug()
        .then((response) => {
          this.datagram = response.data;
          //Cuidado esto puede cortar el lleado del array
          //en caso de que no exista algún campo
          this.populateRows();
        })
        .catch((e) => {
          console.log(e);
        });
    },

    populateRows() {
      //Create struct before insert it
      let newData = null;
      //Add to array
      this.rows = [];
      for (let i = 0; i < this.datagram.length; i++) {
        //Fill the struct
        newData = {
          id: this.datagram[i]._id,
          fecharegistro: this.$moment(String(this.datagram[i].createdAt))
            .local()
            .format("DD-MM-YYYY HH:mm:ss"),
          datagrama: this.datagram[i].datagram_rawdata
          /*Be carefull -> inverted quote to multiple html lines -> Now as slot*/
          /*acciones: ''*/
        };
        //Push the data to the array
        this.rows.push(newData);
      }
    },

    toggleTimer() {
      if (this.checked) {
        this.stopTimer();
      } else {
        this.initTimer();
      }
      this.checked = !this.checked;
    },

    stopTimer() {
      clearInterval(this.timer);
      this.timerCounter = this.timerTicks;
    },

    initTimer() {
      this.timerCounter = this.timerTicks;
      this.timer = setInterval(this.tickTimer, this.timerInterval);
    },

    tickTimer() {
      if (this.timerCounter < 1) {
        this.timerCounter = this.timerTicks;
        this.retrieveDatagrams();
      } else {
        this.timerCounter = this.timerCounter - 1;
        this.timerCheckText = "ON(" + this.timerCounter.toString() + ")";
      }
      //console.log(this.timerCounter)
    },
  },
  mounted() {
    this.retrieveDatagrams();
  },

  created() {
    this.initTimer();
  },

  beforeDestroy() {
    this.stopTimer();
  },
};
</script>

<style lang="css" scoped>
.minDatagram {
  line-height: 1.5em;
  height: 3em;
  overflow: hidden;
}

.minDatagramAlt {
  line-height: 1.5em;
  height: 3em;
  overflow: visible;
}
</style>